import React, { useEffect, useContext, useMemo, useRef } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Switch from "react-switch";
import countryList from "react-select-country-list";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import authService from "../services/authservices";
import Select from "react-select";
import { ScaleLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import i18n from "../translate/i18n";

function Profile() {
  const [checked, setChecked] = useState(false);
  const { logout } = useContext(UserContext);
  const [toastVisible, setToastVisible] = useState(false);
  const { theme } = useContext(UserContext);
  const [verificationCode, setVerificationCode] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(60);
  const [signloader, setSignloader] = useState(false);
  const [mailMask, setEmailmask] = useState("");
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  const [whatsappMask, setWhatsappmask] = useState("");
  const [user, setUser] = useState({
    tfaStatus: 0,
    emailStatus: 0,
    email: null,
    uid: null,
    referralCode: null,
    referralUrl: null,
    displayname: null,
    phone: null,
    country: null,
    isAuthenticated: false,
    profile_image: "",
  });
  const [loading, setLoading] = useState(true);
  const [buttonLoader, setbuttonLoader] = useState(false);
  const fetchUserDetails = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await authService.getUserDetails(token);
        // console.log(data, "--->data<---", data.emailStatus);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            emailStatus: data.emailStatus,
            WhatsappStatus: data.WhatsappStatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            phone: data.phone,
            referralUrl: data.referralUrl,
            profile_image: data.profile_image,
          };
          setUser(userDetails);
          if (data.email != "" && data.email != "N/A") {
            const userEmail = data.email;
            const maskedEmail = maskEmail(userEmail);
            // console.log(maskedEmail);
            setEmailmask(maskedEmail);
          } else {
            setEmailmask(data.email);
          }
          // if (data.phone !== "" && data.phone !== "N/A") {
          //   const userphone = data.phone;
          //   const maskedPhone = maskWhatsapp(userphone); // Masking the phone number
          //   setWhatsappmask(maskedPhone);
          // } else {
          //   setWhatsappmask("Invalid phone number");
          // }
        } else {
          setUser({
            isAuthenticated: false,
            tfaStatus: 0,
            emailStatus: 0,
            WhatsappStatus: 0,
            email: null,
            uid: null,
            referralCode: null,
            phone: null,
            country: null,
            referralUrl: null,
            profile_image: null,
          });
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          emailStatus: 0,
          WhatsappStatus: 0,
          email: null,
          uid: null,
          referralCode: null,
          phone: null,
          country: null,
          referralUrl: null,
          profile_image: null,
        });
      }
    } else {
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        emailStatus: 0,
        WhatsappStatus: 0,
        phone: null,
        country: null,
        email: null,
        uid: null,
        referralCode: null,
        referralUrl: null,
        profile_image: null,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const maskEmail = (email) => {
    const [name, domain] = email.split("@");
    const maskedName = name.slice(0, 3) + "****";
    return maskedName + "@" + domain;
  };
  const maskWhatsapp = (mobile) => {
    const masked = mobile.slice(0, 3) + "****" + mobile.slice(7);
    return masked;
  };

  const navigate = useNavigate();
  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
  };
  const options = useMemo(() => countryList().getData(), []);

  const [username, setUsername] = useState(user.displayname || "");
  const [country, setCountry] = useState(user.country || "");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalVerifyOpen, setIsModalVerifyOpen] = useState(false);
  const [IsModalOpenPhone, setIsModalOpenPhone] = useState(false);
  const [isModalVerifyOpenWhatsapp, setIsModalVerifyOpenWhatsapp] =
    useState(false);
  const [editableField, setEditableField] = useState("");
  const [inputValue, setInputValue, inputValueref] = useState("");
  const [email, setEmail] = useState(user.email || "");
  const [error, setError] = useState("");
  const [selectedStrategy, setSelectedStrategy] = useState([]);
  const [phone, setPhone, phoneValueref] = useState("");

  const [strategyOptions, setStrategyOptions] = useState([]);
  const openModal = (field) => {
    setEditableField(field);
    if (field === "username") {
      setInputValue(user.displayname);
    } else if (field === "country") {
      setSelectedCountry(
        options.find((option) => option.value === user.country)
      );
    } else if (field === "email") {
      setInputValue(user.email);
    } else if (field === "strategy") {
      setSelectedStrategy(
        strategyOptions.find((option) => option.value === user.strategy)
      );
    }
    setIsModalOpen(true);
  };
  const openModalPhone = (field) => {
    setIsModalOpenPhone(true);
    setPhone(field ? field : "");
  };

  const handleVerifyopen = () => {
    setIsModalVerifyOpen(true);
  };
  const handleVerifyopenWhatsapp = () => {
    setIsModalVerifyOpenWhatsapp(true);
  };

  const handleVerifyclose = () => {
    setIsModalVerifyOpen(false);
    setIsModalOpen(false);
    setError("");
    setIsModalOpenPhone(false);
    setIsModalVerifyOpenWhatsapp(false);
    setIsModalVerifyOpen(false);
    setEmailveritrue(false);
    setWhatsappveritrue(false);
    setVerifywhatsappnum(false);
  };
  const handleVerifycloseWhatsapp = () => {
    setIsModalVerifyOpenWhatsapp(false);
    setIsModalOpen(false);
    setError("");
    setIsModalOpenPhone(false);
    setIsModalVerifyOpenWhatsapp(false);
    setIsModalVerifyOpen(false);
    setEmailveritrue(false);
    setWhatsappveritrue(false);
    setVerifywhatsappnum(false);
  };

  const handleModalclose = async () => {
    setIsModalOpen(false);
    setError("");
    setIsModalOpenPhone(false);
    setIsModalVerifyOpenWhatsapp(false);
    setIsModalVerifyOpen(false);
    setEmailveritrue(false);
    setWhatsappveritrue(false);
    setVerifywhatsappnum(false);
  };

  const [selectedCountry, setSelectedCountry] = useState(
    options.find((option) => option.value === user.country) || null
  );

  const [userSubscriptionName, setUserSubscriptionName] = useState("");
  const [filteredStrategyOptions, setFilteredStrategyOptions] = useState([]);

  const [activeStrategy, setActiveStrategy] = useState("");

  useEffect(() => {
    const fetchSubscriptionAndStrategy = async () => {
      const subscriptionResponse = await authService.getUserSubscription();
      if (subscriptionResponse && subscriptionResponse.subscriptionName) {
        setUserSubscriptionName(subscriptionResponse.subscriptionName);
        setFilteredStrategyOptions(
          filterStrategyOptions(subscriptionResponse.subscriptionName)
        );
      }

      const strategyResponse = await authService.getUserActiveStrategy();
      if (strategyResponse && strategyResponse.strategy) {
        setActiveStrategy(strategyResponse.strategy);
      }
    };

    fetchSubscriptionAndStrategy();
  }, []);

  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
    } else {
      document.body.classList.add("light");
      document.body.classList.remove("dark");
    }

    localStorage.setItem("theme", theme);
  }, [theme]);

  const filterStrategyOptions = (subscriptionName) => {
    let allowedStrategies = [];
    if (subscriptionName === "Freemium") {
      allowedStrategies = ["Intra Strategy"];
    } else if (subscriptionName === "Premium") {
      allowedStrategies = ["Intra Strategy", "DCA", "Arbitrage Strategy"];
    } else if (subscriptionName === "Pro") {
      allowedStrategies = [
        "Intra Strategy",
        "DCA",
        "Arbitrage Strategy",
        "Triangle Strategy",
      ];
    }
    return strategyOptions.filter((option) =>
      allowedStrategies.includes(option.value)
    );
  };
  const handleInputChange = (e) => {
    // console.log("------");
    let value = e.target.value;
    setError("");
    if (value.startsWith(" ")) {
      value = value.trimStart(); // Remove the leading space
    }
    if (editableField === "username") {
      // const sanitizedValue = value.replace(/[^a-zA-Z0-9]/g, "");

      if (value.length === 0) {
        setError("Username cannot be empty"); // Error if input is empty
      } else {
        setError(""); // Clear error if input is valid
      }

      if (value.length <= 50 || value.length === 0) {
        setInputValue(value); // Update state only for valid input or if cleared
      }
    } else if (editableField === "email") {
      const regex = /^[^\s]*$/;
      if (!regex.test(value) || value.length > 250) {
        setError(
          "Invalid email. No spaces allowed and must be under 250 characters."
        );
      } else {
        setInputValue(value);
      }
    }
  };

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption.value);
  };

  const handleSaveChanges = async () => {
    setbuttonLoader(true);
    if (
      !inputValue &&
      editableField !== "country" &&
      editableField !== "strategy"
    )
      return;

    if (editableField === "username") {
      if (inputValue.endsWith(" ")) {
        setError("Input cannot end with a space.");
        return;
      }
    }

    if (editableField === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(inputValue)) {
        setError("Invalid email format.");
        return;
      }
    }

    const updatedData = {};
    if (editableField === "username" && inputValue !== user.displayname) {
      updatedData.displayname = inputValue;
    }
    if (editableField === "email" && inputValue !== user.email) {
      updatedData.email = inputValue;
    }
    if (editableField === "country" && selectedCountry !== user.country) {
      const selectedCountryLabel = options.find(
        (option) => option.value === selectedCountry
      )?.label;
      updatedData.country = selectedCountryLabel;
    }

    if (editableField === "strategy") {
      const selectedStrategyArray = Array.isArray(selectedStrategy)
        ? selectedStrategy
        : [];
      const selectedStrategyNames = selectedStrategyArray
        .map((option) => option.value)
        .filter(Boolean);

      if (selectedStrategyArray.length === 0) {
        showErrorToast("Please select at least one strategy before saving.");
        return;
      }
      setbuttonLoader(false);

      try {
        const response = await authService.saveUserStrategy({
          stratagyName: selectedStrategyNames, // Send valid strategy names
        });
        setbuttonLoader(true);

        if (response && (response.status === 200 || response.status === 201)) {
          fetchUserDetails();
          setbuttonLoader(false);
          setIsModalOpen(false); // Close the modal
          setUser((prev) => ({
            ...prev,
            strategy: selectedStrategyArray.map((s) => s.value), // Update user strategies
          }));
          showSuccessToast(response.message);
          const strategyResponse = await authService.getUserActiveStrategy();
          if (strategyResponse && strategyResponse.strategy) {
            setActiveStrategy(strategyResponse.strategy);
          }
        } else {
          showErrorToast(response.message || "Unexpected error");
          fetchUserDetails();
          setbuttonLoader(false);
        }
        setbuttonLoader(false);
      } catch (error) {
        console.error("Error saving strategy:", error);
        showErrorToast(
          error.response?.data?.message || "An unexpected error occurred."
        );
        fetchUserDetails();
        setbuttonLoader(false);
      }
      return;
    }

    if (Object.keys(updatedData).length === 0) {
      // toast.info(
      //   <div className="toast-ml">
      //     <h4 className="toast-title">Info!</h4>
      //     <p className="toast-message">No changes detected.</p>
      //   </div>
      // );
      setIsModalOpen(false);
      setbuttonLoader(false);
      return;
    }

    try {
      const response = await authService.updateUserDetails(updatedData);
      // console.log("Backend Response:", response);
      setbuttonLoader(true);
      if (response && response.status) {
        fetchUserDetails();
        setbuttonLoader(false);
        setIsModalOpen(false);
        setUser((prev) => ({
          ...prev,
          ...updatedData,
        }));
        showSuccessToast("Profile updated successfully");
      } else {
        fetchUserDetails();
        setbuttonLoader(false);
        showErrorToast(
          response.message || "Failed to update user details. Please try again."
        );
      }
    } catch (error) {
      console.error("Error updating user details:", error);
      fetchUserDetails();
      setbuttonLoader(false);
      showErrorToast(
        error.response?.data?.message ||
          "An error occurred while updating user details."
      );
    }
  };
  const handleSaveChangesPhone = async () => {
    if (isValidPhone(phone)) {
      await whatsappSubmit(phone);
      setVerifywhatsappnum(true);
      // setbuttonLoader(true);

      // try {
      //   const response = await authService.updatePhoneNumber({phoneNumber : phone});
      //   setbuttonLoader(true);
      //   if (response && response.status) {
      //     fetchUserDetails();
      //     setbuttonLoader(false);
      //     setIsModalOpenPhone(false);
      //     showSuccessToast("Phone number updated successfully");
      //   } else {
      //     fetchUserDetails();
      //     setbuttonLoader(false);
      //     showErrorToast("Failed to update user details. Please try again.");
      //   }
      // } catch (error) {
      //   console.error("Error updating user details:", error);
      //   fetchUserDetails();
      //   setbuttonLoader(false);
      //   showErrorToast("An error occurred while updating user details.");
      // }
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };
  const copyToClipboard = ((word) => {
    let toastVisible = false; // Track visibility of toast
    let timeout = null; // Debounce logic

    return (text) => {
      if (toastVisible) return; // Prevent showing multiple toasts

      if (timeout) clearTimeout(timeout); // Clear previous timeout

      timeout = setTimeout(() => {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            toastVisible = true;
            toast.success(
              <div className="toast-ml">
                <h4 className="toast-title">Success!</h4>
                <p className="toast-message">Invitation Link Copied</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false; // Reset toast visibility after closing
                },
              }
            );
          })
          .catch((err) => {
            console.error("Failed to copy text:", err);
            toastVisible = true;
            toast.error(
              <div className="toast-ml">
                <h4 className="toast-title">Error!</h4>
                <p className="toast-message">Failed to copy text</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false; // Reset toast visibility after closing
                },
              }
            );
          });
      }, 300); // Optional debounce time
    };
  })();
  const copyToCode = ((word) => {
    let toastVisible = false; // Track visibility of toast
    let timeout = null; // Debounce logic

    return (text) => {
      if (toastVisible) return; // Prevent showing multiple toasts

      if (timeout) clearTimeout(timeout); // Clear previous timeout

      timeout = setTimeout(() => {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            toastVisible = true;
            toast.success(
              <div className="toast-ml">
                <h4 className="toast-title">Success!</h4>
                <p className="toast-message">Invitation Code Copied</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false; // Reset toast visibility after closing
                },
              }
            );
          })
          .catch((err) => {
            console.error("Failed to copy text:", err);
            toastVisible = true;
            toast.error(
              <div className="toast-ml">
                <h4 className="toast-title">Error!</h4>
                <p className="toast-message">Failed to copy code</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false; // Reset toast visibility after closing
                },
              }
            );
          });
      }, 300); // Optional debounce time
    };
  })();
  const copyToClipboardurlcopy = (() => {
    let toastVisible = false;
    let timeout = null;

    return (text) => {
      if (toastVisible) return;

      if (timeout) clearTimeout(timeout);

      timeout = setTimeout(() => {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            toastVisible = true;
            toast.success(
              <div className="toast-ml">
                <h4 className="toast-title">Success!</h4>
                <p className="toast-message">Link copied to clipboard</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false;
                },
              }
            );
          })
          .catch((err) => {
            console.error("Failed to copy text:", err);
            toastVisible = true;
            toast.error(
              <div className="toast-ml">
                <h4 className="toast-title">Error!</h4>
                <p className="toast-message">Failed to copy text</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false;
                },
              }
            );
          });
      }, 300);
    };
  })();

  // const copyToClipboardurlcopy = (() => {
  //   let toastVisible = false;
  //   return () => {
  //     if (!user.referralUrl) {
  //       console.warn("No referral URL to copy.");
  //       return;
  //     }

  //     if (toastVisible) return;

  //     navigator.clipboard
  //       .writeText(user.referralUrl)
  //       .then(() => {
  //         toastVisible = true;
  //         toast("Link copied to clipboard!", {
  //           onClose: () => {
  //             toastVisible = false;
  //           },
  //         });
  //       })
  //       .catch((err) => {
  //         console.error("Failed to copy: ", err);
  //         toastVisible = true;
  //         toast("Failed to copy link!", {
  //           onClose: () => {
  //             toastVisible = false;
  //           },
  //         });
  //       });
  //   };
  // })();

  const isValidPhone = (phone) => {
    // Using a regex for validating phone numbers
    const regex =
      /^\+?\d{1,4}?[-.\s]?\(?\d{1,4}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
    if (phone && regex.test(phone)) {
      setError(""); // Clear error if valid
      return true;
    } else {
      setError("Please enter a valid phone number.");
      return false;
    }
  };

  const copyToClipboardlink = (() => {
    let toastVisible = false;
    return () => {
      const referralCode = user.referralCode;

      if (!referralCode) {
        console.warn("Referral code is missing.");
        return;
      }
      const referralUrl = `/register?invite=${referralCode}`;

      if (toastVisible) return;

      navigator.clipboard
        .writeText(referralUrl)
        .then(() => {
          toastVisible = true;
          toast("Link copied to clipboard!", {
            onClose: () => {
              toastVisible = false;
            },
          });
          navigate(referralUrl);
        })
        .catch((err) => {
          console.error("Failed to copy or navigate: ", err);
          toastVisible = true;
          toast("Failed to copy the link!", {
            onClose: () => {
              toastVisible = false;
            },
          });
        });
    };
  })();

  const customStyles = {
    control: (styles) => ({
      ...styles,
      // backgroundColor: "#f9f9f9",
      // border: "1px solid #ccc",
      // padding: "4px",
      backgroundColor: theme === "dark" ? "transparent" : "#f9f9f9",
      //   border: `1px solid ${theme === "dark" ? "#2b3139" : "#ccc"}`,
      padding: "4px",
      color: theme === "dark" ? "#eaecef" : "#000",
      //   border: "none",
      boxShadow: "none", // Removes the box-shadow
      outline: "none", // Removes any outline
    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      color: theme === "dark" ? "#eaecef" : "#000",
      backgroundColor: isFocused
        ? theme === "dark"
          ? "#444"
          : "#e0e0e0"
        : theme === "dark"
        ? "#181a20"
        : "#fff",
      cursor: "pointer",
    }),
    input: (provided) => ({
      ...provided,
      height: "50px", // Consistent height for input inside the select
      margin: "0", // Ensure the margin does not affect the height
      padding: "0", // Padding inside input
      color: theme === "dark" ? "#a5a0a0" : "#909090",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? theme === "dark"
          ? "#444"
          : "#444"
        : state.isFocused
        ? theme === "dark"
          ? "#333"
          : "#f0f0f0"
        : theme === "dark"
        ? "#181a20"
        : "#ffffff", // Background color for selected and hovered options
      color: state.isSelected ? "#20a1fd" : "#eaecef", // Text color for selected option
      fontFamily: '"Helvetica", sans-serif',
      cursor: "pointer",
      margin: "0px",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: theme === "dark" ? "#181a20" : "#ffffff", // Background of the dropdown menu
      borderColor: theme === "dark" ? "#444" : "#dfdede",
      borderRadius: "10px", // Custom border-radius for the dropdown menu
      overflow: "hidden",
      scrollbarWidth: "thin", // For Firefox
      scrollbarColor: theme === "dark" ? "#555 #222" : "#ccc #f9f9f9", // For Firefox
      "&::-webkit-scrollbar": {
        width: "8px", // Scrollbar width
      },
      "&::-webkit-scrollbar-track": {
        background: theme === "dark" ? "#222" : "#f9f9f9", // Scrollbar track color
      },
      "&::-webkit-scrollbar-thumb": {
        background: theme === "dark" ? "#555" : "#ccc", // Scrollbar thumb color
        borderRadius: "4px", // Rounded scrollbar thumb
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: theme === "dark" ? "#666" : "#aaa", // Hover color for the thumb
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#909090", // Color of the selected value
      fontFamily: '"Helvetica", sans-serif',
    }),
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchStrategies = async () => {
      try {
        const strategies = await authService.topStratagies(token);
        const strategyOptions = strategies.data.map((strategy) => ({
          value: strategy.stratagyName,
          label: strategy.stratagyName,
        }));
        setStrategyOptions(strategyOptions);
      } catch (error) {
        console.error("Error fetching strategies:", error);
      }
    };

    fetchStrategies();
  }, []);

  const handleStrategyChange = (selectedOptions) => {
    // console.log("Selected Strategies:", selectedOptions); // Debugging
    if (Array.isArray(selectedOptions)) {
      setSelectedStrategy(selectedOptions); // Update state
    } else {
      setSelectedStrategy([]); // Reset if no options selected
    }
  };

  const [emailveritrue, setEmailveritrue] = useState(false);
  const [whatsAppveritrue, setWhatsappveritrue] = useState(false);
  const [verifywhatsappnum, setVerifywhatsappnum] = useState(false);

  const emailSubmit = async () => {
    try {
      setOtpSent(true);
      setSignloader(true);
      setTimer(60);
      // console.log("otpsent --> ", otpSent);
      const response = await authService.resendOtp({ email: user.email });
      // console.log(response, "response---<<");
      if (response.data.status) {
        // console.log("otpsent --> ", otpSent);
        setSignloader(false);
        setEmailveritrue(true);
        setVerificationCode("");
        showSuccessToast(response.message || "OTP sent successfully!");
        // setTimer(60);
      } else {
        setSignloader(false);
        setVerificationCode("");
        showErrorToast(
          response.message || "Failed to send OTP. Please try again."
        );
        setOtpSent(false);
      }
    } catch (error) {
      setSignloader(false);
      setVerificationCode("");
      showErrorToast(
        error.response?.data?.message || "An error occurred. Please try again"
      );
      setOtpSent(false);
    }
  };
  const whatsappSubmit = async (phoneData) => {
    try {
      setOtpSent(true);
      setSignloader(true);
      setTimer(60);
      // console.log("otpsent --> ", otpSent);

      const payload = phoneData
        ? { phone: phoneData, changephonenumber: true }
        : { phone: user.phone, changephonenumber: false };

      const response = await authService.whatsAppsendOtp(payload);

      // console.log(response, "response---<<");
      if (response.status) {
        // console.log("otpsent --> ", otpSent);
        setSignloader(false);
        setWhatsappveritrue(true);
        setVerifywhatsappnum(true);
        setVerificationCode("");
        showSuccessToast(response.Message || "OTP sent successfully!");
        // setTimer(60);
      } else {
        setSignloader(false);
        setVerificationCode("");
        showErrorToast(
          response.Message || "Failed to send OTP. Please try again."
        );
        setOtpSent(false);
      }
    } catch (error) {
      setSignloader(false);
      setVerificationCode("");
      showErrorToast(
        error.response?.data?.Message || "An error occurred. Please try again"
      );
      setOtpSent(false);
    }
  };
  const whatsappSubmitResend = async () => {
    try {
      setOtpSent(true);
      setSignloader(true);
      setTimer(60);
      const response = await authService.resendWhatsappOtp({
        mobile: user.phone,
      });
      // console.log(response, "response---<<");
      if (response.status) {
        setSignloader(false);
        setWhatsappveritrue(true);
        setVerifywhatsappnum(true);
        setVerificationCode("");
        showSuccessToast(
          response.message || "OTP resent successfully via WhatsApp"
        );
        // setTimer(60);
      } else {
        setSignloader(false);
        setVerificationCode("");
        setIsModalVerifyOpenWhatsapp(false);
        setWhatsappveritrue(false);
        showErrorToast("Failed to send OTP. Please try again.");
        setOtpSent(false);
      }
    } catch (error) {
      setSignloader(false);
      setVerificationCode("");
      setWhatsappveritrue(false);
      showErrorToast(
        error.response?.data?.message || "An error occurred. Please try again"
      );
      setOtpSent(false);
    }
  };

  // const [error, setError] = useState("");

  const handleInputEmailChange = (e) => {
    const value = e.target.value;
    if (value.length <= 6 && /^[0-9]*$/.test(value)) {
      setVerificationCode(value);
    }
    if (value.length == "") {
      setError("OTP is required!");
    } else {
      setError("");
    }
    // if (error) {
    //   setError("");
    // }
  };
  const handleKeyDown = (e) => {
    // Allow only numbers, Backspace, and Ctrl+V
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Tab",
    ]; // Allow navigation keys and Backspace

    if (
      !/[0-9]/.test(e.key) && // Restrict non-numeric keys
      !allowedKeys.includes(e.key) && // Allow specific keys
      !(e.ctrlKey && e.key === "v") // Allow Ctrl+V for paste
    ) {
      e.preventDefault();
    }

    const value = e.target.value;

    if (value.length >= 6 && e.key !== "Backspace") {
      e.preventDefault();
    }
  };

  useEffect(() => {
    let countdown;
    if (timer > 0 && otpSent) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setOtpSent(false);
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [timer, otpSent]);

  const handleSubmit = async (e) => {
    const value = e.target.value;
    e.preventDefault();
    if (!verificationCode) {
      setError("OTP is required");
      return;
    }
    if (/^\d*$/.test(value)) {
      setVerificationCode(value);
      if (error) {
        setError("");
      }
    }
    try {
      setSignloader(true);
      const response = await authService.verifyOtpProf({
        email: user.email ? user.email : localStorage.getItem("useremail"),
        emailOtp: Number(verificationCode),
      });
      // console.log("response-->>", response);
      if (response.status) {
        setSignloader(false);
        showSuccessToast(response.message || "Email verified successfully!");
        setIsModalVerifyOpen(false);
        fetchUserDetails();
      } else {
        setSignloader(false);
        showErrorToast(response.Message);
      }
    } catch (error) {
      setSignloader(false);
      console.error("Error during OTP verification:", error);
      setError("An error occurred. Please try again.");
    }
  };

  const handleWhatsapp = async (phoneData) => {
    if (!verificationCode) {
      setError("OTP is required");
      return;
    }

    if (!/^\d{6}$/.test(verificationCode)) {
      setError("OTP must be exactly 6 digits");
      return;
    }

    try {
      setSignloader(true);
      const response = await authService.verifyWhatsappOtp({
        mobile: phoneData ? phoneData : user.phone,
        otp: Number(verificationCode),
      });
      // console.log("response-->>", response);
      if (response.status) {
        showSuccessToast(
          response.message || "Phone Number verified successfully!"
        );
        setIsModalOpenPhone(false);
        fetchUserDetails();
        setIsModalVerifyOpenWhatsapp(false);
        setVerifywhatsappnum(false);
        setWhatsappveritrue(false);
        setSignloader(false);
      } else {
        setSignloader(false);
        showErrorToast(response.Message);
        setIsModalVerifyOpenWhatsapp(false);
        setIsModalOpenPhone(false);
        setVerifywhatsappnum(false);
      }
    } catch (error) {
      setSignloader(false);
      setIsModalOpenPhone(false);
      setIsModalVerifyOpenWhatsapp(false);
      setVerifywhatsappnum(false);
      console.error("Error during OTP verification:", error);
      setError("An error occurred. Please try again.");
    }
  };

  const fileInputRef = useRef(null);
  const [imageUrl, setImageUrl] = useState("");

  const handleEditClick = () => {
    fileInputRef.current.click(); // Trigger hidden file input
  };

  const handleFileChange = (val) => {
    try {
      const fileExtension = val.name.split(".").at(-1);
      const fileSize = val.size;
      const fileName = val.name;

      if (
        fileExtension != "png" &&
        fileExtension != "jpg" &&
        fileExtension != "jpeg"
      ) {
        toast.error(
          "File does not support. You must use .png or .jpg or .jpeg "
        );
      } else if (fileSize > 10000000) {
        toast.error("Please upload a file smaller than 1 MB");
      } else {
        const data = new FormData();
        data.append("file", val);
        data.append("upload_preset", authService.cloudinary.upload_preset);
        data.append("cloud_name", authService.cloudinary.cloud_name);
        fetch(
          "https://api.cloudinary.com/v1_1/" +
            authService.cloudinary.cloud_name +
            "/auto/upload",
          { method: "post", body: data }
        )
          .then((resp) => resp.json())
          .then(async (data) => {
            const imageUrl = data.secure_url;
            user.profile_image = imageUrl;

            try {
              const response = await authService.updateProfilePicture({
                profile_image: imageUrl,
              });
              setbuttonLoader(true);
              if (response && response.status) {
                fetchUserDetails();
                setbuttonLoader(false);
                showSuccessToast("Profile updated successfully");
              } else {
                fetchUserDetails();
                setbuttonLoader(false);
                showErrorToast(
                  "Failed to update user profile. Please try again."
                );
              }
            } catch (error) {
              console.error("Error updating user profile:", error);
              fetchUserDetails();
              setbuttonLoader(false);
              showErrorToast("An error occurred while updating user profile.");
            }
          })
          .catch((err) => {
            // console.log(err);
            toast.error("Please try again later");
          });
      }
    } catch (error) {
      // console.log(error);
      toast.error("Please try again later");
    }
  };

  return (
    <div>
      <section>
        <Header />
      </section>
      <div className="profile">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>

            <div className="col-xl-9 col-lg-12 profile_pad_top">
              <div className="profile_main">
                <div className="profile_span">{t("Profile")}</div>
                {loading ? (
                  <div className="loader_main loader_mainChange">
                    <ScaleLoader color="#20A1FD" height={10} width={3} />
                    <p>{t("Loading")}</p>
                  </div>
                ) : (
                  <>
                    <div className="row">
                      <div className="col-lg-2">
                        <div className="profile_pos_rel">
                          {user.profile_image != "" &&
                          user.profile_image != null &&
                          user.profile_image != undefined ? (
                            <img
                              src={user.profile_image}
                              alt="usericon"
                              className="user-img-profile"
                            />
                          ) : (
                            <img
                              src={require("../assests/icons/home-user.png")}
                              alt="usericon"
                              className="user-img-profile"
                            />
                          )}
                          <div
                            className="profile_abs_edit"
                            onClick={handleEditClick}
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={require("../assests/icons/profile-edit.png")}
                              alt="Profile edit"
                              className="profile_edit_img"
                            />
                          </div>

                          {/* Hidden File Input */}
                          <input
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            onChange={(e) =>
                              handleFileChange(e.target.files[0])
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-10">
                        <div className="profile_right_totalmain">
                          {/* <div className='profile_right_first'>
                                        <div className='profile_suhead_main'>
                                            <img src={require("../assests/icons/profile-info.png")} alt='Profile Info' className='profile_subheads_logo' />
                                            <span className='profile_suhead_span'>
                                            Personal info
                                            </span>
                                        </div>
                                        <div className='profile_rightbox_main'>
                                            <div className='profile_box_divrow'>
                                                <span className='home-viewasset-span'>Username</span>
                                                <span className='prof_boxcenter_span'>Jhonsnow661@gmail.com</span>
                                                <div className='prof_chang_box'>
                                                    <span className='prof_chang_box_span'>Change</span>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='profile_box_divrow'>
                                                <span className='home-viewasset-span'> User ID</span>
                                                <span className='prof_boxcenter_span'> 28de0ad9-4187-406f-84bd-3863ab6a1ce7</span>
                                                <div className='prof_chang_box'>
                                                    <span className='prof_chang_box_span'>Change</span>
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className='profile_box_divrow'>
                                                <span className='home-viewasset-span'>Country/Region</span>
                                                <span className='prof_boxcenter_span'>India</span>
                                                <div className='prof_chang_box'>
                                                    <span className='prof_chang_box_span'>Change</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                          {/* <div className="profile_right_first">
                        <div className="profile_suhead_main">
                          <img
                            src={require("../assests/icons/profile-info.png")}
                            alt="Profile Info"
                            className="profile_subheads_logo"
                          />
                          <span className="profile_suhead_span">
                            Personal info
                          </span>
                        </div>
                        <div className="profile_rightbox_main">
                          <div className="row">
                            <div className="col-4">
                              <span className="home-viewasset-span">
                                Username
                              </span>
                            </div>
                            <div className="col-4 ">
                              <div className="prof_tablecenter_scroll">
                                <span className="prof_boxcenter_span">
                                  Jhonsnow661@gmail.com
                                </span>
                              </div>
                            </div>
                            <div className="col-4 profile_box_divrow">
                              <button
                                className="prof_chang_box"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                              >
                                <span className="prof_chang_box_span">
                                  Change
                                </span>
                              </button>
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-4">
                              <span className="home-viewasset-span">
                                {" "}
                                User ID
                              </span>
                            </div>
                            <div className="col-4">
                              <div className="prof_tablecenter_scroll">
                                <span className="prof_boxcenter_span">
                                  {" "}
                                  28de0ad9-4187-406f-84bd
                                </span>
                              </div>
                            </div>
                            <div className="col-4 profile_box_divrow">
                              <button
                                className="prof_chang_box"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                              >
                                <span className="prof_chang_box_span">
                                  Change
                                </span>
                              </button>
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-4">
                              <span className="home-viewasset-span">
                                Country/Region
                              </span>
                            </div>
                            <div className="col-4 ">
                              <div className="prof_tablecenter_scroll">
                                <span className="prof_boxcenter_span">
                                  India
                                </span>
                              </div>
                            </div>
                            <div className="col-4 profile_box_divrow">
                              <button
                                className="prof_chang_box"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                              >
                                <span className="prof_chang_box_span">
                                  Change
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> */}
                          <div className="profile_right_first">
                            <div className="profile_suhead_main">
                              <img
                                src={require("../assests/icons/profile-info-dark.png")}
                                alt="Profile Info"
                                className="profile_subheads_logo"
                              />
                              <span className="profile_suhead_span">
                                {t("PersonalInfo")}
                              </span>
                            </div>
                            <div className="profile_rightbox_main">
                              {/* Username Section */}
                              <div className="row">
                                <div className="col-4">
                                  <span className="home-viewasset-span">
                                    {t("Username")}
                                  </span>
                                </div>
                                <div className="col-4 ">
                                  <div className="prof_tablecenter_scroll">
                                    <span className="prof_boxcenter_span">
                                      {user.displayname}
                                    </span>{" "}
                                    {/* Directly use user.displayname */}
                                  </div>
                                </div>
                                <div className="col-4 profile_box_divrow">
                                  <button
                                    className="prof_chang_box"
                                    onClick={() => openModal("username")}
                                  >
                                    <span className="prof_chang_box_span">
                                      {t("Change")}
                                    </span>
                                  </button>
                                </div>
                              </div>

                              <hr />
                              {/* Country Section */}
                              <div className="row">
                                <div className="col-4">
                                  <span className="home-viewasset-span">
                                    {t("Country/Region")}
                                  </span>
                                </div>
                                <div className="col-4">
                                  <div className="prof_tablecenter_scroll">
                                    <span className="prof_boxcenter_span">
                                      {options.find(
                                        (option) =>
                                          option.value === user.country
                                      )?.label || user.country}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-4 profile_box_divrow">
                                  <button
                                    className="prof_chang_box"
                                    onClick={() => openModal("country")}
                                  >
                                    <span className="prof_chang_box_span">
                                      {t("Change")}
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="profile_right_first">
                            <div className="profile_suhead_main">
                              <img
                                src={require("../assests/icons/account-details -dark.png")}
                                alt="Acount details"
                                className="profile_subheads_logo"
                              />
                              <span className="profile_suhead_span">
                                {t("Accountdetails")}
                              </span>
                            </div>
                            <div className="profile_rightbox_main">
                              {/* Email Section */}
                              <div className="row">
                                <div className="col-md-4 col-6 d-flex align-items-center">
                                  <span className="home-viewasset-span">
                                    {t("EmailAddress")}
                                  </span>
                                </div>
                                <div className="col-md-4 col-6 d-flex align-items-center">
                                  <div className="prof_tablecenter_scroll d-flex align-items-center pos_rel">
                                    <div className="">
                                      <span className="prof_boxcenter_span">
                                        {mailMask}
                                      </span>
                                    </div>
                                    {user.email != null &&
                                    user.email != "N/A" &&
                                    user.emailStatus == 0 ? (
                                      <button
                                        className="prof_chang_box_emverine mx-2"
                                        type="button"
                                        onClick={() => handleVerifyopen()}
                                      >
                                        <span className="prof_chang_box_span">
                                          {t("Verify")}
                                        </span>
                                      </button>
                                    ) : user.email != null &&
                                      user.email != "N/A" &&
                                      user.emailStatus == 1 ? (
                                      <div className="verfed_pro_nn newProf_abs_tick">
                                        <i
                                          class="ri-checkbox-circle-fill home_user_info"
                                          style={{
                                            color: "green",
                                            fontSize: "13px",
                                          }}
                                        ></i>
                                        {/* <span style={{ color: "green" }}>
                                          verified
                                        </span> */}
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                <div className="col-4 profile_box_divrow d-flex align-items-center">
                                  {user.email == "N/A" ? (
                                    <button
                                      className="prof_chang_box"
                                      type="button"
                                      onClick={() => openModal("email")}
                                    >
                                      <span className="prof_chang_box_span">
                                        {t("Change")}
                                      </span>
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              {/* <div className="row">
                                <div className="col-md-4 col-6">
                                  <span className="home-viewasset-span">
                                    Phone Number
                                  </span>
                                </div>
                                <div className="col-md-4 col-6">
                                  <div className="prof_tablecenter_scroll d-flex">
                                    <span className="prof_boxcenter_span">
                                      {whatsappMask ? whatsappMask : "---"}
                                    </span>
                                    {user.phone != null &&
                                    user.phone != "N/A" &&
                                    user.WhatsappStatus == 0 ? (
                                      <button
                                        className="prof_chang_box_emverine mx-2"
                                        type="button"
                                        onClick={() =>
                                          handleVerifyopenWhatsapp()
                                        }
                                      >
                                        <span className="prof_chang_box_span">
                                          Verify
                                        </span>
                                      </button>
                                    ) : user.phone != null &&
                                      user.phone != "N/A" &&
                                      user.WhatsappStatus == 1 ? (
                                      <span className="mx-2 verfed_pro_nn verified_icon">
                                        <i
                                          class="ri-checkbox-circle-fill home_user_info"
                                          style={{
                                            color: "green",
                                            fontSize: "14px",
                                          }}
                                        ></i>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                <div className="col-4 profile_box_divrow">
                                  <button
                                    className="prof_chang_box"
                                    type="button"
                                    onClick={() => openModalPhone(user.phone)}
                                  >
                                    <span className="prof_chang_box_span">
                                      Change
                                    </span>
                                  </button>
                                </div>
                              </div> */}
                            </div>
                          </div>
                          {/* <div className="profile_right_first">
                        <div className="profile_suhead_main">
                          <img
                            src={require("../assests/icons/account-details.png")}
                            alt="Acount details"
                            className="profile_subheads_logo"
                          />
                          <span className="profile_suhead_span">
                            Account details
                          </span>
                        </div>
                        <div className="profile_rightbox_main">
                          <div className="row">
                            <div className="col-4">
                              <span className="home-viewasset-span">
                                {" "}
                                Email Address
                              </span>
                            </div>
                            <div className="col-4">
                              <div className="prof_tablecenter_scroll">
                                <span className="prof_boxcenter_span">
                                  Jhonsnow661@gmail.com
                                </span>
                              </div>
                            </div>
                            <div className="col-4 profile_box_divrow">
                              <button
                                className="prof_chang_box"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModalsecond"
                              >
                                <span className="prof_chang_box_span">
                                  Change
                                </span>
                              </button>
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-4">
                              <span className="home-viewasset-span">
                                {" "}
                                login password{" "}
                              </span>
                            </div>
                            <div className="col-4">
                              <div className="prof_tablecenter_scroll">
                                <span className="prof_boxcenter_span">
                                  {" "}
                                  R*********{" "}
                                </span>
                              </div>
                            </div>
                            <div className="col-4 profile_box_divrow">
                              <button
                                className="prof_chang_box"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModalsecond"
                              >
                                <span className="prof_chang_box_span">
                                  Change
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> */}
                          {/* <div className='profile_right_first'>
                                        <div className='profile_suhead_main'>
                                            <img src={require("../assests/icons/profile-share.png")} alt='Share profile' className='profile_subheads_logo' />
                                            <span className='profile_suhead_span'>
                                            Share
                                            </span>
                                        </div>
                                        <div className='profile_rightbox_main'>
                                            <div className='profile_box_divrow'>
                                                <span className='home-viewasset-span'> My invitation code</span>
                                                <span className='prof_boxcenter_span'>https://invest.untrade.io/auth/si...</span>
                                                <div className='prof_chang_box'>
                                                    <span className='prof_chang_box_span'>Change</span>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='profile_box_divrow'>
                                                <span className='home-viewasset-span'> Invitation link </span>
                                                <span className='prof_boxcenter_span'> https://invest.untrade.io/auth/si... </span>
                                                <div className='prof_chang_box'>
                                                    <span className='prof_chang_box_span'>Change</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                          <div className="profile_right_first">
                            <div className="profile_suhead_main">
                              <img
                                src={require("../assests/icons/profile-share.png")}
                                alt="Share profile"
                                className="profile_subheads_logo"
                              />
                              <span className="profile_suhead_span">
                                {t("Referral")}
                              </span>
                            </div>
                            <div className="profile_rightbox_main">
                              <div className="row">
                                <div className="col-4">
                                  <span className="home-viewasset-span">
                                    {" "}
                                    {t("MyInvitationCode")}
                                  </span>
                                </div>

                                <div className="col-4">
                                  <div className="prof_tablecenter_scroll">
                                    <span className="prof_boxcenter_span">
                                      {user.referralCode
                                        ? user.referralCode
                                        : "Loading..."}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-4 profile_box_divrow">
                                  <div
                                    className="prof_chang_box"
                                    onClick={() =>
                                      copyToCode(user.referralCode)
                                    }
                                  >
                                    <span className="prof_chang_box_span">
                                      {t("Copy")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <hr />
                              <div className="row">
                                <div className="col-4">
                                  <span className="home-viewasset-span">
                                    {" "}
                                    {t("InvitationLink")}{" "}
                                  </span>
                                </div>

                                <div className="col-4">
                                  {/* <div className="prof_tablecenter_scroll" onClick={copyToClipboardlink}> */}
                                  <div className="prof_tablecenter_scroll">
                                    <span
                                      className="prof_boxcenter_span"
                                      // onClick={copyToClipboardlink}
                                    >
                                      {user.referralUrl || "Generating link..."}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-4 profile_box_divrow">
                                  <div
                                    className="prof_chang_box"
                                    onClick={() =>
                                      copyToClipboard(user.referralUrl)
                                    }
                                  >
                                    <span className="prof_chang_box_span">
                                      {t("Copy")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="profile_right_first">
                            <div className="profile_suhead_main">
                              <img
                                src={require("../assests/icons/security-withdraw.png")}
                                alt="Withdrawal addresses"
                                className="secu_head_img icons-light"
                              />
                              <img
                                src={require("../assests/icons/security-withdraw-dark.png")}
                                alt="Withdrawal addresses"
                                className="secu_head_img icons-dark"
                              />
                              <span className="profile_suhead_span">
                                {t("WithdrawalAddresses")}
                              </span>
                            </div>
                            <div className="profile_rightbox_main">
                              <div className="row withdraw_head_add ">
                                <div className="col-4">
                                  <span className="home-viewasset-span">
                                    {t("AddYourWithdrawAddress")}
                                  </span>
                                </div>
                                <div className="col-4 display_none"></div>
                                <div className="col-4 profile_box_divrow">
                                  <div className="h-100 d-flex align-items-center">
                                    <Link to="/security-withdraw">
                                      <button
                                        className="prof_chang_box"
                                        type="button"
                                      >
                                        <span className="prof_chang_box_span">
                                          {t("Change")}
                                        </span>
                                      </button>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <div className="row">
                        <div className="col-4">
                          <span className="home-viewasset-span">Strategy</span>
                        </div>
                        <div className="col-4">
                          <div className="prof_tablecenter_scroll">
                            <span className="prof_boxcenter_span">
                              {activeStrategy || "No active strategy"}
                            </span>
                          </div>
                        </div>
                        <div className="col-4 profile_box_divrow">
                          <button className="prof_chang_box" onClick={() => openModal("strategy")}>
                            <span className="prof_chang_box_span">Change</span>
                          </button>
                        </div>
                      </div> */}

                          <div className="profile_right_first">
                            <div className="profile_suhead_main">
                              <img
                                src={require("../assests/icons/profile-setting.png")}
                                alt="Profile setting"
                                className="profile_subheads_logo"
                              />
                              <span className="profile_suhead_span">
                                {t("Settings")}
                              </span>
                            </div>
                            <div className="profile_rightbox_main">
                              {/* <div className="row">
                            <div className="col-4">
                              <span className="home-viewasset-span">
                                {" "}
                                Notification
                              </span>
                            </div>
                            <div className="col-4">
                              <div className="prof_tablecenter_scroll">
                                <span className="prof_boxcenter_span">
                                  Get notified about the trade
                                </span>
                              </div>
                            </div>
                            <div className="col-4 profile_box_divrow">
                              <Switch
                                checked={checked}
                                onChange={handleChange}
                                onColor="#31BD65" // Color inside the switch when on
                                offColor="#b0bec5" // Color inside the switch when off
                                handleDiameter={18} // Diameter of the switch handle (button)
                                height={22} // Height of the switch
                                width={37} // Width of the switch
                                uncheckedIcon={false} // No icon when off
                                checkedIcon={false} // No icon when on
                                handleStyle={{
                                  boxShadow: "none", // This removes the glow or shadow around the handle
                                  backgroundColor: "white", // Ensure the handle is white
                                }}
                              />
                            </div>
                          </div> */}
                              {/* <hr /> */}
                              <div className="row">
                                <div className="col-md-4 col-6">
                                  <span className="home-viewasset-span">
                                    {" "}
                                    {t("ExitBinarge")}{" "}
                                  </span>
                                </div>
                                <div className="col-md-4 display_none"></div>
                                <div className="col-md-4 col-6 profile_box_divrow">
                                  <div
                                    className="prof_bottom_logout"
                                    onClick={handleLogout}
                                  >
                                    <span className="prof_bottom_logout_span">
                                      {t("Logout")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div
                      class="modal fade"
                      id="exampleModal"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered modal-md">
                        <div class="modal-content">
                          <div class="modal-header lvl-one-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">
                              <span className="home_user_display">
                                <img
                                  src={require("../assests/icons/profile-info.png")}
                                  alt="Profile Info"
                                  className="profile_subheads_logo mb-1 mx-2"
                                />{" "}
                                Personal info
                              </span>
                            </h1>
                            <button
                              type="button"
                              class="btn-close btn-close-custom"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body personal_verify_body lvl-one-body">
                            <div className="mt-2 d-flex flex-column gap-3">
                              <div className="profile_edit_inpmain">
                                <span className="home-viewasset-span">
                                  Username
                                </span>
                                <input
                                  type="text"
                                  placeholder="Enter your Username"
                                />
                              </div>
                              <div className="profile_edit_inpmain">
                                <span className="home-viewasset-span">
                                  User ID
                                </span>
                                <input
                                  type="text"
                                  placeholder="Enter your User ID"
                                />
                              </div>
                              <div className="profile_edit_inpmain">
                                <span className="home-viewasset-span">
                                  Country/Region
                                </span>
                                <input
                                  type="text"
                                  placeholder="Enter your Country/Region"
                                />
                              </div>
                              <div className="">
                                <div className="home_topstary_follow">
                                  <span>Save</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                        {isModalOpen && (
                          <div
                            className="modal fade show"
                            style={{ display: "block" }}
                            tabIndex="-1"
                            role="dialog"
                          >
                            <div
                              className="modal-dialog modal-dialog-centered modal-md"
                              role="document"
                            >
                              <div className="modal-content">
                                <div className="modal-header lvl-one-header">
                                  <h1
                                    className="modal-title fs-5"
                                    id="exampleModalLabel"
                                  >
                                    {t("Edit")}{" "}
                                    {editableField.charAt(0).toUpperCase() +
                                      editableField.slice(1)}
                                  </h1>
                                  {/* <span className="btn-close-new" onClick={() => setIsModalOpen(false)}> */}
                                  <span
                                    className="btn-close-new"
                                    onClick={() => handleModalclose()}
                                  >
                                    X
                                  </span>
                                </div>
                                <div className="modal-body personal_verify_body lvl-one-body">
                                  <div className="mt-2 d-flex flex-column gap-3">
                                    <div className="profile_edit_inpmain">
                                      <span className="home-viewasset-span">
                                        {editableField.charAt(0).toUpperCase() +
                                          editableField.slice(1)}
                                      </span>
                                      {editableField === "country" ? (
                                        <Select
                                          options={options}
                                          value={options.find(
                                            (option) =>
                                              option.value === selectedCountry
                                          )} // Ensure value is an object
                                          onChange={handleCountryChange}
                                          placeholder={user.country}
                                          styles={customStyles}
                                          // getOptionLabel={(e) => `${e.label} (${e.value})`}
                                          className="register-country-dropdown"
                                        />
                                      ) : editableField === "strategy" ? (
                                        <Select
                                          options={strategyOptions}
                                          value={selectedStrategy} // Array of selected strategies
                                          onChange={handleStrategyChange}
                                          placeholder={t("SelectYourStrategies")}
                                          styles={customStyles}
                                          className="register-country-dropdown"
                                          isMulti // Enable multi-select
                                          closeMenuOnSelect={false} // Keep dropdown open for multiple selections
                                        />
                                      ) : (
                                        <input
                                          type="text"
                                          placeholder={`${t("EnterYour")} ${editableField}`}
                                          value={inputValueref.current}
                                          onChange={handleInputChange}
                                        />
                                      )}
                                      {error && (
                                        <div
                                          className="error"
                                          // style={{ color: "red", marginTop: "5px", fontSize:"14px" }}
                                        >
                                          {error}
                                        </div>
                                      )}
                                    </div>
                                    <div>
                                      {buttonLoader == true ? (
                                        <button className="btn profile_savebtn">
                                          {t("Loading1")}
                                        </button>
                                      ) : (
                                        <button
                                          className="btn profile_savebtn"
                                          onClick={handleSaveChanges}
                                        >
                                          {t("Save")}
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {IsModalOpenPhone && (
                          <div
                            className="modal fade show"
                            style={{ display: "block" }}
                            tabIndex="-1"
                            role="dialog"
                          >
                            <div
                              className="modal-dialog modal-dialog-centered modal-md"
                              role="document"
                            >
                              <div className="modal-content">
                                <div className="modal-header lvl-one-header">
                                  <h1
                                    className="modal-title fs-5"
                                    id="exampleModalLabel"
                                  >
                                    {t("ChangePhoneNumber")}
                                  </h1>
                                  {/* <span className="btn-close-new" onClick={() => setIsModalOpen(false)}> */}
                                  <span
                                    className="btn-close-new"
                                    onClick={() => handleModalclose()}
                                  >
                                    X
                                  </span>
                                </div>
                                <div className="modal-body personal_verify_body lvl-one-body">
                                  <div className="mt-2 d-flex flex-column gap-3">
                                    {verifywhatsappnum == false ? (
                                      <div className="profile_edit_inpmain profile_edit_inpmainphone">
                                        <span className="home-viewasset-span">
                                          {t("PhoneNumber")}
                                        </span>
                                        <PhoneInput
                                          country={selectedCountry}
                                          value={phone}
                                          onChange={(value) => {
                                            setPhone(value);
                                            setError("");
                                          }}
                                          disableDropdown={false}
                                          className="register-country-dropdown"
                                          styles={customStyles}
                                        />
                                        {error && (
                                          <div className="errorcss">
                                            {error}
                                          </div>
                                        )}

                                        {signloader === true ? (
                                          <button className="btn profile_savebtn">
                                            {t("Loading")}
                                          </button>
                                        ) : (
                                          <button
                                            className="btn profile_savebtn"
                                            onClick={() =>
                                              whatsappSubmit(phone)
                                            }
                                          >
                                            {t("Verify")}
                                          </button>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="profile_edit_inpmain">
                                        <span className="newveri_pro_po">
                                          {t("EnterOTPToVerify")}
                                        </span>
                                        <div className="reg_pos_rel">
                                          <input
                                            type="number"
                                            name="emailOtp"
                                            className="w-100"
                                            value={verificationCode}
                                            placeholder={t("EnterTheVerificationCode")}
                                            onChange={handleInputEmailChange}
                                            onKeyDown={handleKeyDown}
                                          />
                                          {otpSent ? (
                                            <span className="pos_abs_resend_proem">
                                              {t("Resend")} ({timer}s)
                                            </span>
                                          ) : (
                                            <span
                                              className="pos_abs_resend_proem"
                                              onClick={whatsappSubmitResend}
                                              style={{ cursor: "pointer" }}
                                            >
                                              {t("Resend")}
                                            </span>
                                          )}
                                        </div>
                                        {error && (
                                          <span className="error">{error}</span>
                                        )}
                                        {signloader === true ? (
                                          <button className="btn profile_savebtn">
                                            {t("Loading")}
                                          </button>
                                        ) : (
                                          <button
                                            className="btn profile_savebtn"
                                            onClick={() => {
                                              handleWhatsapp(phone);
                                            }}
                                          >
                                            {t("Submit")}
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {isModalVerifyOpen && (
                          <div
                            className="modal fade show"
                            style={{ display: "block" }}
                            tabIndex="-1"
                            role="dialog"
                          >
                            <div
                              className="modal-dialog modal-dialog-centered modal-md"
                              role="document"
                            >
                              <div className="modal-content">
                                <div className="modal-header lvl-one-header">
                                  <h1
                                    className="modal-title fs-5"
                                    id="exampleModalLabel"
                                  >
                                    {t("VerifyYourEmail")}
                                  </h1>
                                  <span
                                    className="btn-close-new"
                                    onClick={() => handleVerifyclose()}
                                  >
                                    X
                                  </span>
                                </div>
                                <div className="modal-body personal_verify_body lvl-one-body">
                                  <div className="mt-2 d-flex flex-column gap-3">
                                    {emailveritrue == false ? (
                                      <div className="profile_edit_inpmain">
                                        <span className="newveri_pro_po">
                                          {t("ClickEmail")}
                                        </span>
                                        {signloader === true ? (
                                          <button className="btn profile_savebtn">
                                            {t("Loading")}
                                          </button>
                                        ) : (
                                          <button
                                            className="btn profile_savebtn"
                                            onClick={emailSubmit}
                                          >
                                            {t("Verify")}
                                          </button>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="profile_edit_inpmain">
                                        <span className="newveri_pro_po">
                                          {t("EnterOTPToVerify")}
                                        </span>
                                        <div className="reg_pos_rel">
                                          <input
                                            type="number"
                                            name="emailOtp"
                                            className="w-100"
                                            value={verificationCode}
                                            placeholder={t("EnterTheVerificationCode")}
                                            onChange={handleInputEmailChange}
                                            onKeyDown={handleKeyDown}
                                          />
                                          {otpSent ? (
                                            <span className="pos_abs_resend_proem">
                                              {t("Resend")} ({timer}s)
                                            </span>
                                          ) : (
                                            <span
                                              className="pos_abs_resend_proem"
                                              onClick={emailSubmit}
                                              style={{ cursor: "pointer" }}
                                            >
                                              {t("Resend")}
                                            </span>
                                          )}
                                        </div>
                                        {error && (
                                          <span className="error">{error}</span>
                                        )}
                                        {signloader === true ? (
                                          <button className="btn profile_savebtn">
                                            {t("Loading")}
                                          </button>
                                        ) : (
                                          <button
                                            className="btn profile_savebtn"
                                            onClick={handleSubmit}
                                          >
                                            {t("Submit")}
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {isModalVerifyOpen && (
                          <div
                            className="modal fade show"
                            style={{ display: "block" }}
                            tabIndex="-1"
                            role="dialog"
                          >
                            <div
                              className="modal-dialog modal-dialog-centered modal-md"
                              role="document"
                            >
                              <div className="modal-content">
                                <div className="modal-header lvl-one-header">
                                  <h1
                                    className="modal-title fs-5"
                                    id="exampleModalLabel"
                                  >
                                    {t("VerifyYourEmail")}
                                  </h1>
                                  <span
                                    className="btn-close-new"
                                    onClick={() => handleVerifyclose()}
                                  >
                                    X
                                  </span>
                                </div>
                                <div className="modal-body personal_verify_body lvl-one-body">
                                  <div className="mt-2 d-flex flex-column gap-3">
                                    {emailveritrue == false ? (
                                      <div className="profile_edit_inpmain">
                                        <span className="newveri_pro_po">
                                          {t("ClickEmail")}
                                        </span>
                                        {signloader === true ? (
                                          <button className="btn profile_savebtn">
                                            {t("Loading")}
                                          </button>
                                        ) : (
                                          <button
                                            className="btn profile_savebtn"
                                            onClick={emailSubmit}
                                          >
                                            {t("Verify")}
                                          </button>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="profile_edit_inpmain">
                                        <span className="newveri_pro_po">
                                          {t("EnterOTPToVerify")}
                                        </span>
                                        <div className="reg_pos_rel">
                                          <input
                                            type="number"
                                            name="emailOtp"
                                            className="w-100"
                                            value={verificationCode}
                                            placeholder={t("EnterTheVerificationCode")}
                                            onChange={handleInputEmailChange}
                                            onKeyDown={handleKeyDown}
                                          />
                                          {otpSent ? (
                                            <span className="pos_abs_resend_proem">
                                              {t("Resend")} ({timer}s)
                                            </span>
                                          ) : (
                                            <span
                                              className="pos_abs_resend_proem"
                                              onClick={emailSubmit}
                                              style={{ cursor: "pointer" }}
                                            >
                                              {t("Resend")}
                                            </span>
                                          )}
                                        </div>
                                        {error && (
                                          <span className="error">{error}</span>
                                        )}
                                        {signloader === true ? (
                                          <button className="btn profile_savebtn">
                                            {t("Loading")}
                                          </button>
                                        ) : (
                                          <button
                                            className="btn profile_savebtn"
                                            onClick={handleSubmit}
                                          >
                                            {t("Submit")}
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {isModalVerifyOpenWhatsapp && (
                          <div
                            className="modal fade show"
                            style={{ display: "block" }}
                            tabIndex="-1"
                            role="dialog"
                          >
                            <div
                              className="modal-dialog modal-dialog-centered modal-md"
                              role="document"
                            >
                              <div className="modal-content">
                                <div className="modal-header lvl-one-header">
                                  <h1
                                    className="modal-title fs-5"
                                    id="exampleModalLabel"
                                  >
                                    {t("VerifyYourPhoneNumber")}
                                  </h1>
                                  <span
                                    className="btn-close-new"
                                    onClick={() => handleVerifycloseWhatsapp()}
                                  >
                                    X
                                  </span>
                                </div>
                                <div className="modal-body personal_verify_body lvl-one-body">
                                  <div className="mt-2 d-flex flex-column gap-3">
                                    {whatsAppveritrue == false ? (
                                      <div className="profile_edit_inpmain">
                                        <span className="newveri_pro_po">
                                          {t("ClickPhoneNumber")}
                                        </span>
                                        {signloader === true ? (
                                          <button className="btn profile_savebtn">
                                            {t("Loading")}
                                          </button>
                                        ) : (
                                          <button
                                            className="btn profile_savebtn"
                                            onClick={() => whatsappSubmit()}
                                          >
                                            {t("Verify")}
                                          </button>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="profile_edit_inpmain">
                                        <span className="newveri_pro_po">
                                          {t("EnterOTPToVerify")}
                                        </span>
                                        <div className="reg_pos_rel">
                                          <input
                                            type="number"
                                            name="emailOtp"
                                            className="w-100"
                                            value={verificationCode}
                                            placeholder={t("EnterTheVerificationCode")}
                                            onChange={handleInputEmailChange}
                                            onKeyDown={handleKeyDown}
                                          />
                                          {otpSent ? (
                                            <span className="pos_abs_resend_proem">
                                              {t("Resend")} ({timer}s)
                                            </span>
                                          ) : (
                                            <span
                                              className="pos_abs_resend_proem"
                                              onClick={whatsappSubmitResend}
                                              style={{ cursor: "pointer" }}
                                            >
                                              {t("Resend")}
                                            </span>
                                          )}
                                        </div>
                                        {error && (
                                          <span className="error">{error}</span>
                                        )}
                                        {signloader === true ? (
                                          <button className="btn profile_savebtn">
                                            {t("Loading")}
                                          </button>
                                        ) : (
                                          <button
                                            className="btn profile_savebtn"
                                            onClick={() => handleWhatsapp()}
                                          >
                                            {t("Submit")}
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        <div
                          class="modal fade"
                          id="exampleModalsecond"
                          tabindex="-1"
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog modal-dialog-centered modal-md">
                            <div class="modal-content">
                              <div class="modal-header lvl-one-header">
                                <h1
                                  class="modal-title fs-5"
                                  id="exampleModalLabel"
                                >
                                  <span className="home_user_display">
                                    <img
                                      src={require("../assests/icons/account-details.png")}
                                      alt="Acount details"
                                      className="profile_subheads_logo mb-1 mx-2"
                                    />{" "}
                                    {t("Accountdetails")}
                                  </span>
                                </h1>
                                <button
                                  type="button"
                                  class="btn-close btn-close-custom"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body personal_verify_body lvl-one-body">
                                <div className="mt-2 d-flex flex-column gap-3">
                                  <div className="profile_edit_inpmain">
                                    <span className="home-viewasset-span">
                                      {t("EmailAddress")}
                                    </span>
                                    <input
                                      type="text"
                                      placeholder={t("EnterYourEmailAddress")}
                                    />
                                  </div>
                                  <div className="profile_edit_inpmain">
                                    <span className="home-viewasset-span">
                                      {t("loginPassword")}
                                    </span>
                                    <input
                                      type="text"
                                      placeholder={t("EnterYourLoginPassword")}
                                    />
                                  </div>
                                  <div className="mt-3">
                                    <div className="home_topstary_follow">
                                      <span>{t("Save")}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
